/**
 * Slider 스타일
 * @description 좌우 패딩과 항목 간 갭을 한 축으로 묶는다. 갭은 좌우 여백과 **따로** 정한다 —
 *   탭 화면(`sm`)은 좌우 여백만 줄었고 카드끼리 떨어진 거리는 그대로이기 때문이다.
 *
 *   좌우 패딩은 스크롤 상자 자신에게 준다. 상자는 화면 폭을 다 써야 스크롤이 가장자리까지
 *   가고, 오른쪽 끝 패딩도 스크롤 영역 안에 남는다(현대 브라우저는 overflow 상자의 끝 패딩을
 *   스크롤 범위에 넣는다).
 */
import { cva } from "class-variance-authority";

export const sliderStyles = {
  frame: cva("relative flex min-w-0 w-full flex-col", {
    variants: {
      padding: {
        none: "[--slider-inset:0px]",
        sm: "[--slider-inset:var(--fw-inset-tab)]",
        lg: "[--slider-inset:var(--fw-inset-screen)]",
      },
    },
    defaultVariants: { padding: "lg" },
  }),
  control:
    "absolute top-1/2 z-10 hidden -translate-y-1/2 rounded-full shadow-[0_2px_8px_var(--fw-color-effect-shadow)] tablet:block",
  /** 스크롤 상자의 바깥 여백을 제외한 카드 영역 안쪽에 버튼을 놓는다. */
  controlPrevious:
    "left-[calc(var(--slider-inset)+var(--fw-space-inset-sm))]",
  controlNext:
    "right-[calc(var(--slider-inset)+var(--fw-space-inset-sm))]",
  root: cva(
    [
      /*
       * 크기 컨테이너다 — 줄 안의 카드가 `cqw` 로 줄 폭에서 제 폭을 계산한다("세 장 + 네 번째의
       * 옆구리"). 앱은 창 폭에서 계산하는데, 웹은 콘텐츠 열이 창보다 좁을 수 있어 줄 자신의
       * 폭이 기준이어야 한다.
       */
      "@container flex w-full overflow-x-auto",
      "[scrollbar-width:none] [&::-webkit-scrollbar]:hidden",
      "cursor-grab select-none active:cursor-grabbing",
    ],
    {
      variants: {
        padding: {
          none: "",
          sm: "px-[var(--fw-inset-tab)]",
          lg: "px-[var(--fw-inset-screen)]",
        },
        gap: {
          sm: "gap-[var(--fw-space-gap-sm)]",
          md: "gap-[var(--fw-space-gap-md)]",
        },
        /** 그림자 자리를 낸 만큼 되돌린다 — 섹션 사이 간격은 변하지 않는다 */
        bleed: {
          none: "",
          shadow: "-my-[var(--fw-space-gap-xl)] py-[var(--fw-space-gap-xl)]",
        },
      },
      defaultVariants: { padding: "lg", gap: "sm", bleed: "none" },
    },
  ),
  item: "shrink-0",
  /** 끝을 감지하는 보초 — 크기가 없어 화면에 보이지 않는다 */
  sentinel: "w-px shrink-0 self-stretch",
};
